/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';

import { TableComponent } from '@angular-kit/view';

@Component({
  selector: 'kit-bs-table',
  templateUrl: './bs-table.component.html',
  styleUrls: ['./bs-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BsTableComponent extends TableComponent {
  // TODO: add explicit constructor


  get hostClass(): string {
    return null;
  }

}
